import {AbstractControl} from '@angular/forms';

export const isControlRequired = (control: AbstractControl): boolean => {
	if (!control) return false;
	return !!(control.validator && control.validator({} as AbstractControl)?.required);
};
